// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Pin: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="m21.51 7.48-5-5a1.656 1.656 0 0 0-1.175-.487c-.459 0-.874.186-1.175.487-.302.295-.49.706-.49 1.16V3.669c0 .37.12.71.323.988l-.003-.005-5 5H6.11a1.995 1.995 0 0 0-1.38.57 1.938 1.938 0 0 0-.001 2.77l1.77 1.81c.238.2.454.406.656.625l.004.005-4.87 4.87a1 1 0 1 0 1.41 1.42l4.85-4.85.47.46 2 1.94a2 2 0 0 0 3.34-1.375V15l5-5a1.66 1.66 0 0 0 2.64-1.34V8.65a1.653 1.653 0 0 0-.49-1.17h.001ZM18.66 8l-6 6a.996.996 0 0 0-.28.679l-.07 3.28-6.2-6.35h3.25a1 1 0 0 0 .67-.28l6-6a.924.924 0 0 0 .238-.392l.002-.007 2.8 2.8a.83.83 0 0 0-.409.269h-.001Z" />
  </SvgIcon>
);

Pin.activeColor = 'inherit';
Pin.muiName = 'Pin';
